import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { History, Home, User, Wallet } from "lucide-react";

const ORANGE = "#f97316";

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const tabs = [
    { name: "History", path: "/bids",      icon: History },
    { name: "Deposit", path: "/deposit",   icon: AllBidsIcon },
    { name: "Home",    path: "/dashboard",  icon: Home },
    { name: "Wallet",  path: "/wallet",     icon: Wallet },
    { name: "Profile", path: "/profile",   icon: User },
  ];

  const handleTab = (tab) => {
    if (tab.path === "/dashboard") { navigate("/dashboard"); return; }
    navigate(user ? tab.path : "/login");
  };

  return (
    <div style={navBar}>
      {tabs.map((tab) => {
        const active = location.pathname === tab.path;
        const Icon = tab.icon;
        return (
          <button
            key={tab.name}
            type="button"
            style={navBtn}
            onClick={() => handleTab(tab)}
          >
            <span style={active ? activeIconWrap : iconWrap}>
              <Icon size={20} color={active ? ORANGE : "#94a3b8"} strokeWidth={active ? 2.5 : 1.8} />
            </span>
            <span style={{ ...label, color: active ? ORANGE : "#94a3b8", fontWeight: active ? 800 : 600 }}>
              {tab.name}
            </span>
          </button>
        );
      })}
    </div>
  );
}

function AllBidsIcon({ size, color, strokeWidth }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

const navBar = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  height: "60px",
  background: "#fff",
  borderTop: "1px solid #e2e8f0",
  display: "flex",
  alignItems: "stretch",
  zIndex: 100,
  boxShadow: "0 -2px 12px rgba(0,0,0,0.07)",
};
const navBtn = {
  flex: 1,
  border: 0,
  background: "transparent",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "2px",
  cursor: "pointer",
  padding: "4px 0",
  WebkitTapHighlightColor: "transparent",
};
const iconWrap = { display: "grid", placeItems: "center" };
const activeIconWrap = { ...iconWrap };
const label = { fontSize: "10px", lineHeight: 1.2, textAlign: "center" };

export default BottomNav;
